import React, { Component } from 'react';
import styles from '../scss/Download.scss';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import RequestView from './RequestView';

export class Cart extends Component {

    state = {
        geoDatasets: [],
        allSites: [],
        geoDatasetsSelected: {},
        profileDatasets: [],
        profileDatasetsSelected: {},

        geoDatasetsPayload: "",
        profileDatasetsPayload: {},

        geoDatasetsBySites: [],
        profileDatasetsBySites: []
    }

    componentDidMount() {
        if (this.props.show) {
            this.restore();
        }
    }

    restore = () => {
        const geoDatasetsString = localStorage.getItem("geoDatasets");
        let geoDatasets = [];
        if (geoDatasetsString) {
            geoDatasets = JSON.parse(geoDatasetsString);
        }
        const allSitesString = localStorage.getItem("allSites");
        let allSites = [];
        if (allSitesString) {
            allSites = JSON.parse(allSitesString);
        }
        const geoDatasetsSelectedString = localStorage.getItem("geoDatasetsSelected");
        let geoDatasetsSelected = {};
        if (geoDatasetsSelectedString) {
            geoDatasetsSelected = JSON.parse(geoDatasetsSelectedString);
        }

        const profileDatasetsString = localStorage.getItem("profileDatasets");
        let profileDatasets = [];
        if (profileDatasetsString) {
            profileDatasets = JSON.parse(profileDatasetsString);
        }
        const profileDatasetsSelectedString = localStorage.getItem("profileDatasetsSelected");
        let profileDatasetsSelected = {};
        if (profileDatasetsSelectedString) {
            profileDatasetsSelected = JSON.parse(profileDatasetsSelectedString);
        }

        this.setState({
            geoDatasets: geoDatasets,
            allSites: allSites,
            geoDatasetsSelected: geoDatasetsSelected,
            profileDatasets: profileDatasets,
            profileDatasetsSelected: profileDatasetsSelected
        }, () => {
            this.generatePayloads();
        });
    }

    generatePayloads = () => {
        // Geospatial Datasets
        const geoDatasetsIds = [];
        Object.keys(this.state.geoDatasetsSelected).forEach(key => {
            const ids = this.state.geoDatasetsSelected[key];
            ids.forEach(id => geoDatasetsIds.push(parseInt(id)));
        });

        // Profile Datasets
        const profileDatasetsPayload = {};
        Object.keys(this.state.profileDatasetsSelected).forEach(key => {
            const site = this.state.profileDatasets.find(s => s.name === key);
            const selectedIds = this.state.profileDatasetsSelected[key];

            // Get unique surveys
            const surveyIds = [...new Set(selectedIds.map((id) => {
                return id.split("_")[1];
            }))];

            const surveys = {};
            surveyIds.forEach((surveyId) => {
                const tracnsectIds = [];
                selectedIds.forEach((selectedId) => {
                    const parts = selectedId.split("_");
                    if (parseInt(parts[0]) === parseInt(site.id) && parseInt(parts[1]) === parseInt(surveyId)) {
                        tracnsectIds.push(parseInt(parts[2]));
                    }
                });
                surveys[surveyId.toString()] = tracnsectIds;
            });
            profileDatasetsPayload[site.id.toString()] = surveys;
        });

        this.setState({
            geoDatasetsPayload: geoDatasetsIds.join(","),
            profileDatasetsPayload: profileDatasetsPayload
        }, () => {
            this.generatePreviewData();
        });
    }

    generatePreviewData = () => {
        // Geospatial Datasets
        const geoDatasetsBySites = [];
        this.state.geoDatasetsPayload.split(",").forEach((id) => {
            const geoDataset = this.state.geoDatasets.find(g => g.id === parseInt(id));
            const site = this.state.allSites.find(s => s.name === geoDataset.siteName);

            let geoDatasetsBySite = geoDatasetsBySites.find(g => g.site.name === geoDataset.siteName);
            if (!geoDatasetsBySite) {
                geoDatasetsBySite = {
                    site: site,
                    surveys: []
                };
                geoDatasetsBySites.push(geoDatasetsBySite);
            }

            geoDatasetsBySite.surveys.push(geoDataset);
        });

        // Profile Datasets
        const profileDatasetsBySites = [];
        Object.keys(this.state.profileDatasetsPayload).forEach(siteId => {
            const site = this.state.profileDatasets.find(s => s.id === parseInt(siteId));
            const surveysInPayload = this.state.profileDatasetsPayload[siteId];

            const surveys = [];
            Object.keys(surveysInPayload).forEach(surveyId => {
                const survey = site.surveys.find(s => s.id === parseInt(surveyId));
                const transectsInPayload = surveysInPayload[surveyId.toString()];
                const transectNames = transectsInPayload.map((transectId) => {
                    return survey.transects.find(t => t.id === transectId).name;
                });

                surveys.push({
                    name: survey.name,
                    transects: transectNames.sort().join(", ")
                });
            });
            profileDatasetsBySites.push({
                site: site,
                surveys: surveys
            });
        });

        this.setState({
            geoDatasetsBySites: geoDatasetsBySites,
            profileDatasetsBySites: profileDatasetsBySites
        });
    }

    componentDidUpdate(prevProps) {
    }

    submitRequest = () => {
        console.log("[geoDatasetsPayload]", this.state.geoDatasetsPayload);
        console.log("[profileDatasetsPayload]", this.state.profileDatasetsPayload);

        // TODO: clean up localStorage after successful submission
    }

    render() {
        return (
            <div >
                <RequestView
                    profileDatasetsBySites={this.state.profileDatasetsBySites}
                    geoDatasetsBySites={this.state.geoDatasetsBySites}                
                />                
                <div className="request-view-footer"  >
                    <button onClick={this.submitRequest}><i className="fas fa-paper-plane"></i>Submit Request</button>
                </div>
            </div>
        )
    }
}

export default Cart
